import { REDIRECT_KEY } from 'App/scenes/Login/Login';
import { FEATURE_TOGGLES, useFeatureToggle } from 'sharedComponents/FeatureToggle';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import { setItem } from 'util/localStorage';
import ERROR_CODES from '../../../util/errorCodes';
import { signoutZitadel } from '../../actions/zitadel';
import Loading from '../../components/Loading';
import NoRoles from '../../components/NoRoles';
import { useFeatureContext } from '../FeatureProvider/FeatureProvider';
import { useOrganizationShortNameHandler } from './useOrganizationShortNameHandler';

const Initialize = ({
  children,
  user,
  organizationShortName,
  configurationInitialized,
  token,
  initialize,
  initializeFoundation,
  invalidRoles,
}) => {
  const location = useLocation();
  const foundationFeature = useFeatureToggle(FEATURE_TOGGLES.FOUNDATION);
  const { initialized: featuresInitialized } = useFeatureContext();
  const [criticalError, setCriticalError] = useState(false);
  useOrganizationShortNameHandler(organizationShortName);

  const initializeCallback = useCallback(async () => {
    if (foundationFeature) {
      const init = await initializeFoundation();
      if (Error.isError(init) && init.message === ERROR_CODES.HTTP_RESPONSE_STATUS_UNAUTHORIZED) {
        signoutZitadel();
      } else if (Error.isError(init)) {
        setCriticalError(init);
      }
    } else if (token && !foundationFeature) {
      initialize();
    }
  }, [initialize, foundationFeature, token, initializeFoundation]);

  useEffect(() => {
    initializeCallback();
  }, [initializeCallback]);

  const isDoneLoading = useMemo(
    () => !!user.userId && !!organizationShortName && featuresInitialized && configurationInitialized,
    [user, organizationShortName, featuresInitialized, configurationInitialized]
  );

  if (criticalError) {
    throw criticalError;
  }

  if (invalidRoles) {
    return <NoRoles signout={signoutZitadel} />;
  }
  if (!token && !foundationFeature) {
    const redirectPath = location.pathname + (location.search || '');
    setItem(REDIRECT_KEY, redirectPath);
    return <Navigate to="/login" replace />;
  } else if (isDoneLoading) {
    return children;
  } else {
    return <Loading />;
  }
};

export default Initialize;
